import { useEffect } from 'react';

import { observer } from 'mobx-react';

import { useStores } from '../../../stores/useStores';

import RegularTournamentWidget from './RegularTournamentWidget';
import TournamentOfChampionsWidget from './TournamentOfChampionsWidget';

function preloadTournamentDialog() {
  void import('../../Dialogs/TournamentDialog/TournamentDialog');
}

const TournamentWidget = observer(function TournamentWidget() {
  const { tournamentOfChampionsStore } = useStores();

  useEffect(() => {
    preloadTournamentDialog();
  }, []);

  if (tournamentOfChampionsStore.shouldShowWidget) {
    return <TournamentOfChampionsWidget />;
  }

  if (tournamentOfChampionsStore.holdsTournamentSlot) {
    return null;
  }

  return <RegularTournamentWidget />;
});

export default TournamentWidget;
